export default __webpack_public_path__ + "static/NotoSansJP-Bold-f4ec346348e497f2e2a5872fd14327e9.woff";